<div class="organization-details-card">
  <company-block-card [title]="organization.businessName" [isMarginBottom]="true" [isTitleTranslatable]="false">
    <ng-container card-actions>
      <div *ngIf="isAdmin" class="header-container__actions" (click)="redirectToOrganizationEdit(organization.id)">
        <img src="assets/icons/edit_gray.svg" />
        <span *ngIf="!(isTablet$ | async)">{{ "BUTTON.EDIT" | translate }}</span>
      </div>
    </ng-container>

    <ng-container card-body>
      <div class="info-container">
        <div class="info-container__logo" *ngIf="!!organization?.logoUri">
          <img src="{{ organization.logoUri }}" />
        </div>

        <div class="info-container__logo-upload" *ngIf="!organization?.logoUri">
          <document-upload-logo
            [id]="'organization-logo-' + organization.id"
            [isLoading]="isLoadingLogo"
            (upload)="uploadOrganizationLogo($event, organization.id)"
          ></document-upload-logo>
        </div>

        <div class="w-100">
          <ng-container *ngIf="isHasOnboardingRedesign && !!organization?.businessDetails">
            <div class="info-container__item">
              <span class="label">{{ "LABELS.BUSINESS_TYPE" | translate | titlecase }}</span>
              <span class="value" *ngIf="!!organization?.businessDetails?.type">
                {{ "LABELS.COMPANY_TYPE_CARD." + enumOrganizationType[organization?.businessDetails?.type] + ".TITLE" | translate }}
              </span>
            </div>

            <div class="info-container__item" *ngIf="!!organization?.businessDetails?.category">
              <span class="label">{{ "LABELS.INDUSTRY" | translate | titlecase }}</span>
              <span class="value">
                {{ organization?.businessDetails?.category }}
              </span>
            </div>

            <div class="info-container__item">
              <span class="label">{{ "LABELS.SIZE" | translate | titlecase }}</span>
              <span class="value" *ngIf="!!organization?.businessDetails?.organizationSize">
                {{
                  "LABELS.COMPANY_SHIPMENT_TYPE_CARD." + enumOrganizationSize[organization?.businessDetails?.organizationSize] | translate
                }}
              </span>
            </div>
          </ng-container>

          <div class="info-container__item">
            <span class="label">{{ "LABELS.ORGANIZATION_BUSINESS_ID_NUMBER" | translate | titlecase }}</span>
            <span class="value" *ngIf="!!organization?.identifierQualifier">
              {{ organization?.identifierQualifier | identifierQualifier | translate }}
              {{ organization?.identifier }}
            </span>
          </div>
          <div class="info-container__item">
            <span class="label">{{ "LABELS.ORGANIZATION_BUSINESS_LOCATION" | translate | titlecase }}</span>
            <span class="value">{{ getOrganizationAddressLine(organization) }}</span>
          </div>
          <div class="info-container__item">
            <span class="label">{{ "LABELS.ORGANIZATION_CONTACT_INFO" | translate | titlecase }}</span>
            <div class="value">
              <p
                [ngClass]="{
                  'm-0': !organization?.contactInformation?.businessPhone,
                  value__line: organization?.contactInformation?.businessPhone
                }"
                *ngIf="!!organization?.contactInformation?.businessEmail"
              >
                {{ organization?.contactInformation?.businessEmail }}
              </p>
              <p *ngIf="!!organization?.contactInformation?.businessPhone" class="m-0">
                {{ organization?.contactInformation?.businessPhone }}
              </p>
            </div>
          </div>
          <div class="info-container__item">
            <span class="label">{{ "LABELS.ORGANIZATION_PLAN" | translate | titlecase }}</span>
            <span class="value">{{ getPlanTypeName(organization.subscriptionType) | translate }}</span>
          </div>
        </div>
      </div>
    </ng-container>
  </company-block-card>
</div>
